import React__default, { useRef, useState, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import { D as DropdownPopover } from './DropdownPopover-a65OT6uW.js';
import { S as SelectList } from '../SelectList/SelectList-CKJ1ZhdU.js';
import { u as usePopoverSelectListHelper } from './usePopoverSelectListHelper-DybvIt2E.js';
import { u as useDropdownContext } from './DropdownContext-Cjb3JGE6.js';
import { g as getPlacement } from './utils-B_t3KuC-.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';

/* eslint-disable @typescript-eslint/no-empty-function */
const SelectListWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-k6w712-0"
})(["padding:", ";overflow:hidden auto;"], ({
  theme
}) => theme.spacing.xxsmall.default);
function getSize(elementRef) {
  let height;
  let width;
  if (elementRef && elementRef.current) {
    const size = elementRef.current.getBoundingClientRect();
    height = size.height;
    width = size.width;
  }
  return {
    height,
    width
  };
}
function DesktopContainer({
  isOpen,
  onClose,
  children,
  shadowRoot,
  trigger,
  preRender,
  postRender,
  selectedValue,
  onChange,
  noWrap,
  focusSelectOption,
  anchorEl,
  forceOpen = false,
  maxHeight,
  popoverRef,
  openDirection,
  forceDirection
}) {
  var _theme$dropdown$popov, _theme$dropdown;
  const {
    multiple,
    listboxProps
  } = useDropdownContext();
  const theme = /*#__PURE__*/useTheme();
  const popoverOffsetDistance = (_theme$dropdown$popov = theme === null || theme === void 0 || (_theme$dropdown = theme.dropdown) === null || _theme$dropdown === void 0 || (_theme$dropdown = _theme$dropdown.popover) === null || _theme$dropdown === void 0 ? void 0 : _theme$dropdown.offsetDistance) !== null && _theme$dropdown$popov !== void 0 ? _theme$dropdown$popov : 0;
  const internalRef = useRef(null);
  const {
    height,
    width
  } = getSize(anchorEl);
  const [shouldRenderPopover, setShouldRenderPopover] = useState(false);

  // Delay popover rendering until anchor element is available to prevent positioning issues
  useEffect(() => {
    if (anchorEl !== null && anchorEl !== void 0 && anchorEl.current) {
      setShouldRenderPopover(true);
    }
  }, [anchorEl]);
  const {
    handleEscape,
    handleKeyDown
  } = usePopoverSelectListHelper({
    anchorEl,
    onClose,
    focusAnchorElDisabled: forceOpen
  });
  return /*#__PURE__*/React__default.createElement(DropdownPopover, {
    popoverRef: popoverRef !== null && popoverRef !== void 0 ? popoverRef : internalRef,
    isOpen: shouldRenderPopover && isOpen,
    onClose: onClose,
    offsetDistance: -(Math.abs(height !== null && height !== void 0 ? height : 0) + popoverOffsetDistance),
    $minWidth: width,
    onKeyDown: handleKeyDown,
    popoverElementDidMount: focusSelectOption,
    shadowRoot: shadowRoot,
    trigger: trigger,
    focusFirstElementOnPopoverExited: true,
    listboxProps: listboxProps,
    maxHeight: maxHeight,
    placement: getPlacement(openDirection),
    enableFlip: !forceDirection
  }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    fallbackId: "dropdown-desktop"
  }, preRender === null || preRender === void 0 ? void 0 : preRender(), /*#__PURE__*/React__default.createElement(SelectListWrapper, null, /*#__PURE__*/React__default.createElement(SelectList, {
    selectedValue: selectedValue,
    onChange: onChange,
    noWrap: noWrap,
    afterOnSelect: () => {
      if (!multiple) {
        handleEscape();
      }
    },
    multiple: multiple
  }, children)), postRender === null || postRender === void 0 ? void 0 : postRender()));
}

export { DesktopContainer as D };
//# sourceMappingURL=DropdownDesktopContainer-C9AUBzMw.js.map
